import styled from "@emotion/styled";
import { ActionIconsProps } from "./ActionIcon.types";
import { colorGuide, colorPalette } from "../../theme/colors";

export const ActionIconsContainer = styled.div<{
  gap?: number;
  padding?: string;
  justifyContent?: string;
}>`
  display: flex;
  align-items: center;
  justify-content: ${(props) => props.justifyContent || "center"};
  gap: ${(props) => props.gap || 24}px;
  width: 100%;
  padding: ${(props) => props.padding || "0 20px"};
`;

export const ActionIconWrapper = styled.div<{
  state?: string;
  selectedColor?: string;
}>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;

  ${(props) =>
    props.state === "selected" &&
    `
    background-color: ${props.selectedColor || "#F3F4F6"};
    border: 2px solid ${props.selectedColor || "#8B5CF6"};
  `}

  &:hover {
    background-color: ${colorPalette.popBlack[500]};
  }
`;

export const ActionIcon = styled.i<{
  color?: string;
  selectedColor?: string;
  state?: string;
}>`
  font-size: 20px;
  color: ${(props) => {
    if (props.state === "selected") {
      return props.selectedColor || "#8B5CF6";
    }
    return props.color || colorPalette.popBlack[500];
  }};
  transition: color 0.2s ease;
`;

export const NotificationDot = styled.div<{
  notificationColor?: string;
}>`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(props) => props.notificationColor || "#EF4444"};
  border: 1px solid ${colorPalette.popWhite[500]};
`;

export const CountBadge = styled.div<{
  countColor?: string;
  countTextColor?: string;
}>`
  position: absolute;
  top: -2px;
  right: -2px;
  min-width: 18px;
  height: 18px;
  padding: 0 6px;
  border-radius: 9px;
  background-color: ${(props) => props.countColor || "#EF4444"};
  color: ${(props) => props.countTextColor || "#FFFFFF"};
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${colorPalette.popWhite[500]};
`;
